import React, { memo, useEffect } from "react";
import "./About.css";
import logo from "../logo.jpeg";
import Typed from "typed.js";

// import { saveAs } from "file-saver";

const About = () => {

   const handleClick = () => {
     window.open(
       "https://drive.google.com/file/d/1OPPhvBlcU1gxAyDePRObJPkoi14-ct3a/view?usp=sharing",
       "_blank"
     );
   };
  useEffect(() => {
    var typed = new Typed(".typing-2", {
      strings: ["Prachi Tiwari"],
      typeSpeed: 100,
      backSpeed: 90,
      loop: true,
    });
  }, []);
  return (
    <section
      className="abouta about section"
      id="about"
      style={{
        backgroundColor: "black",
        opacity: "",
        height: "auto",
        border: "1px solid black",
      }}
    >
      <div
        style={{
          textAlign: "center",
          fontSize: "40px",
          marginTop: "30px",
          marginBottom: "50px",
          fontWeight: "bold",
        }}
      >
        <h1> About</h1>
      </div>

      <div className="max-width">
        <div className="about-content">
          <div className="column left">
            <img className="home-img" src={logo} alt="hi" />
          </div>
          <div className="column right">
            <div id="user-detail-name" className="text">
              Hello Everyone ,I am <span className="typing-2"></span>
            </div>
            <p id="user-detail-intro">
              and an enthusiastic Front-end Web Developer, skilled in Full Stack
              Web Development. Having knowledge of MERN ,JavaScript, HTML, CSS.
              High adaptability to learn new technologies quickly and paying
              attention to details.
            </p>
            <button
            onClick={handleClick}
              id="resume-button-2"
              className="nav-link resume"
            >
              <a
                id="resume-link-2"
                href="Prachi-Tiwari-Resume.pdf"
                target="_blank"
                download
              >
                RESUME
              </a>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(About);
